export const PUBLIC_PATHS = ["/", "/privacy", "/login", "/signup", "/forgot-password"] as const;

export function isPublicPath(pathname: string): boolean {
  if (pathname.startsWith("/reset-password")) return true;
  if (pathname.startsWith("/documents/share/")) return true;
  return PUBLIC_PATHS.includes(pathname as (typeof PUBLIC_PATHS)[number]) || pathname === "/privacy" || pathname.startsWith("/privacy/");
}

/** Invitation acceptance pages that must mount for logged-out users (Sign in required UI). */
export function isInvitationSharePath(pathname: string): boolean {
  return (
    pathname.startsWith("/workspaces/share/") ||
    pathname.startsWith("/spaces/share/") ||
    pathname.startsWith("/agents/share/") ||
    pathname.startsWith("/agents/folders/share/") ||
    pathname.startsWith("/threads/share/") ||
    pathname.startsWith("/topics/share/")
  );
}

/** Same-origin relative path only; rejects open redirects (`//evil.com`). */
export function getSafeReturnTo(raw: string | null | undefined, fallback = "/"): string {
  if (!raw) return fallback;
  const path = raw.trim();
  if (!path.startsWith("/") || path.startsWith("//")) return fallback;
  return path;
}

export function buildLoginUrlWithReturnTo(pathname: string, search = ""): string {
  const returnTo = getSafeReturnTo(`${pathname}${search}`);
  if (returnTo === "/") return "/login";
  return `/login?returnTo=${encodeURIComponent(returnTo)}`;
}
